// Module
var code = "<toolbar-emoji-menu emojis=\"parent.elementEmojis\" menu-type=\"text\" on-select=\"parent.createEmoji(emoji)\"> </toolbar-emoji-menu> ";
// Exports
module.exports = code;